import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Environment } from '../../../core/services/common';
import { LogService } from './log.service';
import { SecureStoreService } from './storage/secure.service';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  private isReady = false;
  private appUpdatedVersion: number;

  constructor(
    private platform: Platform,
    private logService: LogService,
    private secure: SecureStoreService
  ) {}

  private async ready() {
    if (this.isReady) {
      return Promise.resolve();
    }
    await Promise.all([
      this.secure.getNotSecure('updateVersionKey'),
      this.platform.ready()
    ]).then(([updateVersionKey]: [number, string]) => {
      this.appUpdatedVersion = updateVersionKey == null ? 0 : updateVersionKey;
    });
    this.isReady = true;
  }

  async updateData() {
    await this.ready();
    const { updateToVersion } = Environment.config();
    const storedVersion = (await this.getAppUpdatedVersion()) || 9999;

    if (storedVersion < updateToVersion) {
      this.logService.i(
        this,
        `Starting updating service. Current version: ${storedVersion}`
      );
      this.secure.deleteLegacyKeys();
      await this.storeAppUpdatedVersion(storedVersion);
    }
  }

  private async getAppUpdatedVersion() {
    return this.appUpdatedVersion;
  }

  private async storeAppUpdatedVersion(appUpdatedVersion: number) {
    this.appUpdatedVersion = appUpdatedVersion;
    this.secure.saveNotSecure('updateVersionKey', this.appUpdatedVersion);
  }
}
